import { useLocation } from 'react-router';

import { catchAll } from '@sorare/routing';

import { ANY_SPORT_MY_CARDS } from '#src/constants/__generated__/routes.ts';
import { useSeriesNav } from '#src/hooks/commonGame/useSeriesNav.ts';
import { useFeatureFlags } from '#src/hooks/useFeatureFlags.tsx';
import { matchAnySportPath } from '#src/lib/routing/generateSportPath.ts';

export const useEnableSeriesNavigationUpdate = () => {
  const seriesNav = useSeriesNav();
  const { pathname } = useLocation();
  const isMyCards = !!matchAnySportPath(catchAll(ANY_SPORT_MY_CARDS), pathname);
  const {
    // flag to control series-related navigation updates
    // but not restricted to simplified nav users (header, my cards changes, etc.)
    flags: { enableSeriesNavigationUpdate = false },
  } = useFeatureFlags();
  return seriesNav || (enableSeriesNavigationUpdate && isMyCards);
};
